export interface StatamicForm {
    handle: string
    title: string
    fields: Record<string, Field>
    success_message: string
    error_message: string
    submit_button_label: string
}

export interface StatamicFormRequest {
    handle: string
}

export interface StatamicFormSubmissionRequest {
    handle: string
    data: any
}

export interface StatamicFormSubmissionResponse {}

export const useStatamicForms = () => {
    const statamic = useStatamic()

    const getForm = <T extends StatamicForm>(req: StatamicFormRequest) =>
        statamic<T>(`/forms/${req.handle}`)

    const submit = (
        req: StatamicFormSubmissionRequest,
    ): Promise<StatamicFormSubmissionResponse> =>
        useStatamicPost().submit(`/forms/${req.handle}/submit`, req.data)

    return {
        getForm,
        submit,
    }
}
